import axios from "axios";
import { getCookie } from "./getCookie";

export const createAPIwithNextValue = (path: string) => {
  const token = getCookie("token");
  return axios.create({
    baseURL: `${path}`,
    headers: {
      "Content-Type": "application/json",
      // See createApi: never send "Bearer undefined".
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
};
